"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // export const urlLogin = "http://www.dreamchimney.com/tracks/login";
// const base = process.env.NODE_ENV === "production" ? `http://www.dreamchimney.com` : `http://www.dc.local`;
// import { getAuthHeader } from "~/utils/headers";

var base = ""; // uses php api
// export const urlLogin = base + "/api/tracks/login";

var urlLogin = exports.urlLogin = base + "/login";
var urlRegister = exports.urlRegister = base + "/register";
var urlPasswordForgot = exports.urlPasswordForgot = base + "/forgot";
var urlPasswordReset = exports.urlPasswordReset = base + "/reset";
var urlGetUser = exports.urlGetUser = base + "/api/tracks/user";
var urlUploadAvatar = exports.urlUploadAvatar = base + "/api/tracks/user/avatar"; // php version

var urlUserValidate = exports.urlUserValidate = base + "/api/user/validate";
var urlUserProfile = exports.urlUserProfile = base + "/profile"; // export const urlUserProfileEditRead = base + "/profile/edit";

var urlUserFavorites = exports.urlUserFavorites = base + "/favorites";
var urlUserSocial = exports.urlUserSocial = base + "/social"; // node express version, not used yet
// export const urlUserValidate = base + "/validate";
// export const userValidate = (axios, urlUserValidate, vals) => axios.post(`${urlUserValidate}`, vals);

var userLogin = exports.userLogin = function userLogin(axios, urlLogin, vals) {
  return axios.post("" + urlLogin, vals);
};

var userPasswordForgot = exports.userPasswordForgot = function userPasswordForgot(axios, vals) {
  return axios.post("" + urlPasswordForgot, vals);
};

var userPasswordReset = exports.userPasswordReset = function userPasswordReset(axios, vals) {
  return axios.post("" + urlPasswordReset, vals);
};

var userRegister = exports.userRegister = function userRegister(axios, urlRegister, vals) {
  return axios.post("" + urlRegister, vals);
};

var getUser = exports.getUser = function getUser(axios, urlGetUser, vals) {
  return axios.post("" + urlGetUser, vals);
};